
import axios from "axios";
import authService from "./authService";
export const TOKEN_KEY = "token";
// export const BASE_IMAGE_URL = "http://127.0.0.1:8000/";   
// export const BASE_IMAGE_URL = "https://gdrbpharma.axylotech.com/public/"
export const BASE_IMAGE_URL = "https://gdrbpharmacy.ziweto.in/public/"
const apiService = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API,
});

apiService.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    const publicRoutes = [
      "auth/login",
      "auth/register",
      "auth/resend-otp",
      "auth/verify-otp",
      "auth/admin-login",
      "auth/password/request-otp",
      "auth/password/reset",
      "auth/login-send-otp",
      "auth/login-verify-otp",

    ];
    const isPublicRoute = publicRoutes.some(route =>
      config.url.includes(route)
    );
    if (!token && !isPublicRoute) {
      return Promise.reject(new Error("No token available"));
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiService.interceptors.response.use(
  (response) => response,
  (error) => {

    if (
      error.response?.status === 401 &&
      !error.config.url.includes("auth/login") &&
      !error.config.url.includes("auth/admin-login")
    ) {
      authService.logout();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

apiService.getAll = (endpoint) => apiService.get(endpoint);
apiService.getById = (endpoint, id) => apiService.get(`${endpoint}/${id}`);
apiService.create = (endpoint, data) => apiService.post(endpoint, data);
apiService.update = (endpoint, id, data) =>
  apiService.put(`${endpoint}/${id}`, data);
apiService.remove = (endpoint, id) =>
  apiService.delete(`${endpoint}/${id}`);

apiService.createWithFile = (endpoint, data) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return apiService.post(endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// apiService.updateWithFile = (endpoint, id, data) => {
//   const formData = new FormData();

//   Object.entries(data).forEach(([key, value]) => {
//     formData.append(key, value);
//   });

//   return apiService.post(`${endpoint}/${id}`, formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   });
// };
apiService.updateWithFile = (endpoint, id, data) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, value);
  });
  formData.append("_method", "PUT");

  return apiService.post(`${endpoint}/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


export default apiService;